import { useState, useEffect, useContext } from "react";
import {
    Box, FormControl, makeStyles,
    CircularProgress, RadioGroup, Radio, IconButton, Tooltip, Dialog, Chip, FormControlLabel
} from "@material-ui/core";
import AddIcon from '@mui/icons-material/Add';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import DoneIcon from '@material-ui/icons/Done';
//Style
import clsx from 'clsx';
//Helpers
import { getStatusNodes } from "../../../services/meters";
import UserContext from '../../../context/UserContext';
import { get_vars_Automate_byId } from '../../../services/plc_automate';
import { getChipLabel } from "../../InstantAdvanced/helpers";
//Componentes
import DatasetFilter from "../../InstantAdvanced/DatasetFilter";

const useStyles = makeStyles(theme => ({
    devicesLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },
    '& .MuiInputLabel-root': {
        marginBottom: '8px',
    },
    addBtn: {
        margin: theme.spacing(0.5),
        marginLeft: theme.spacing(1),
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        height: theme.spacing(3),
        width: theme.spacing(3),
        '&:hover': {
            backgroundColor: 'rgb(54, 143, 193);',
        },
    },
    filterChip: {
        margin: theme.spacing(0.5),
        '@media (max-width: 700px)': {
            width: '250px',
        },
    },
    hint: {
        backgroundColor: 'rgba(0, 0, 0, 0.38)',
        color: theme.palette.common.white,
        height: theme.spacing(3),
        width: theme.spacing(3),
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(1),
        '&:hover': {
            backgroundColor: 'rgb(54, 143, 193);',
        },
    },
    tick: {
        backgroundColor: theme.palette.success.light,
    },
    active: {
        backgroundColor: theme.palette.primary.main,
    },
    radio: {
        height: '150px',
        marginLeft: theme.spacing(1),
        '& .MuiTypography-body1': {
            fontSize: '0.75rem',
        },
        '& > *': {
            flexBasis: '33%',
        },
        '& .MuiFormControlLabel-root': {
            marginRight: 0,
        },
        '@media (max-width: 700px)': {
            height: 'auto',
        },
    },
    tabsTitle: {
        padding: theme.spacing(0.5),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        textTransform: 'uppercase',
        color: theme.palette.primary.main,
        textAlign: 'center',
        borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
}));

export default function FilterInstantAdvcanced({ stateOpenClose, stateComponent, setStateComponent, setDisabledButtonSaveLineInstantAdvancedGraph }) {
    const classes = useStyles();
    const [filter, setFilter] = useState({}); // Inicializa como objeto vacío
    const [openDataSetFilter, setOpenDataSetFilter] = useState(false);
    const { plan } = useContext(UserContext);
    const [activeStep, setActiveStep] = useState(0);
    const [indexDataSetSelected, setIndexDataSetSelected] = useState(null)
    //Loading principal
    const [loading, setLoading] = useState(false);

    const [arrayGranularityValue, setArrayGranularityValue] = useState([
        {
            name: "Hoy",
            key: "HOY",
        },
        {
            name: "Ayer",
            key: "AYER",
        },
        {
            name: "Ultimos 7 dias",
            key: "ULTIMOS_7_DIAS",
        },
        {
            name: "Ultimos 10 dias",
            key: "ULTIMOS_10_DIAS",
        },
        {
            name: "Ultimos 30 dias",
            key: "ULTIMOS_30_DIAS",
        },
        {
            name: "Esta semana",
            key: "ESTA_SEMANA",
        },
        {
            name: "Semana pasada",
            key: "SEMANA_PASADA",
        },
        {
            name: "Ultimas 2 semanas",
            key: "ULTIMAS_2_SEMANAS",
        },
        {
            name: "Este mes",
            key: "ESTE_MES",
        },
        {
            name: "Mes pasado",
            key: "MES_PASADO",
        }
    ]);

    //Inicia el loading
    useEffect(() => {
        setLoading(false)
    }, [stateOpenClose])

    //MERGE DATA
    useEffect(() => {
        if (stateComponent?.filter_key) {
            setFilter({ ...stateComponent.filter_key });
        }
    }, []);

    //Validador de pasos
    useEffect(() => {
        validateSteps()
    }, [stateComponent])

    const validateSteps = () => {
        if (stateComponent?.filter_key?.groups?.['1']?.dataSets?.length > 0) {
            setActiveStep(1);
            if (stateComponent?.filter_key?.range) {
                setActiveStep(2);
                setDisabledButtonSaveLineInstantAdvancedGraph(true);
            }
        }
        else {
            setDisabledButtonSaveLineInstantAdvancedGraph(false);
        }
    }

    //STATUS
    const [statusNodes, setStatusNodes] = useState([]);
    useEffect(() => {
        const getStatusNodesAux = async () => {
            let res = await getStatusNodes();
            let arry = res.data;
            setStatusNodes(arry);
        }
        getStatusNodesAux();
    }, []);

    //CATALOGO DE VARIABLES
    const [VARS_CATALOGO, setVARS_CATALOGO] = useState([]);
    const fetchClientVars = async () => {
        let catalogoLocal = plan?.sections?.["INSTANTANEOS"]?.filter(item => item.enabled) || [];
        let res = await get_vars_Automate_byId();
        setLoading(true)
        if (res?.data?.sections?.VARIABLES) {
            setVARS_CATALOGO([...catalogoLocal, ...res.data.sections.VARIABLES]);
        }
        else {
            setVARS_CATALOGO([...catalogoLocal]);
        }
    }
    useEffect(() => {
        fetchClientVars();
        // eslint-disable-next-line
    }, []);

    const DATASET_INITIAL_VALUES = {
        devices: [],
        alias: '',
        variable: '',
        granularity: '',
        timeslots: '',
        color: '',
    };

    const handleDataSetChanges = (dataset, indexDataSet, indexGroup) => {
        if (dataset?.devices?.length > 1) {
            handleMultiplesDevices(dataset, indexGroup);
        }
        else {
            let filter_key = { ...filter };
            if (!filter_key.groups) filter_key.groups = [];
            if (!filter_key.groups[indexGroup]) {
                filter_key.groups[indexGroup] = { dataSets: [] };
            }
            if (!Array.isArray(filter_key.groups[indexGroup].dataSets)) {
                filter_key.groups[indexGroup].dataSets = [];
            }
            let existentDataset = filter_key.groups[indexGroup].dataSets[indexDataSet];
            if (existentDataset) {
                filter_key.groups[indexGroup].dataSets[indexDataSet] = dataset;
            } else {
                filter_key.groups[indexGroup].dataSets.push(dataset);
            }
            setFilter(filter_key);
            // Si quieres actualizar el componente padre:
            setStateComponent({
                ...stateComponent,
                config_key: 'DASHBOARDS_INSTANT-VALIDATE_INSTANT',
                filter_key: filter_key
            })
        }
    };

    const handleMultiplesDevices = (dataset, indexGroup) => {
        let devices = [...dataset.devices];
        let filter_key = { ...filter };
        if (!filter_key.groups) filter_key.groups = [];
        if (!filter_key.groups[indexGroup]) {
            filter_key.groups[indexGroup] = { dataSets: [] };
        }
        if (!Array.isArray(filter_key.groups[indexGroup].dataSets)) {
            filter_key.groups[indexGroup].dataSets = [];
        }
        let datasets = devices.map((device) => ({
            devices: [device],
            alias: device.nombre,
            color: device.color,
            timeslots: dataset.timeslots,
            variable: dataset.variable,
            granularity: dataset.granularity
        }));
        filter_key.groups[indexGroup].dataSets.push(...datasets);
        setFilter(filter_key);
        setStateComponent({
            ...stateComponent,
            config_key: 'DASHBOARDS_INSTANT-VALIDATE_INSTANT',
            filter_key: filter_key
        })
    };

    const handleDeleteDataSet = (datasetIndex) => {
        let filter_key = { ...filter }
        filter_key?.groups['1']?.dataSets?.splice(datasetIndex, 1)
        setFilter(filter_key)
        setStateComponent({
            ...stateComponent,
            config_key: 'DASHBOARDS_INSTANT-VALIDATE_INSTANT',
            filter_key: filter_key
        })
    }
    const handleOpenDataSet = (datasetIndex) => {
        setIndexDataSetSelected(datasetIndex)
        setOpenDataSetFilter(!openDataSetFilter)
    }

    //Handle rango.
    const handlePeriod = (e) => {
        let value = e.target.value
        setStateComponent({
            ...stateComponent,
            config_key: 'DASHBOARDS_INSTANT-VALIDATE_INSTANT',
            filter_key: {
                ...stateComponent.filter_key,
                range: value,
            }
        });
    }

    const disabledGranularity = () => {
        let flag = true
        if (stateComponent?.filter_key?.groups?.['1']?.dataSets?.length > 0) {
            flag = false
        }
        return flag
    }

    //Agrega el nombre de la variable al label del chip verifico si es una variable personalizada para buscarla por llave en vez de por id
    const validateVarNameSelected = (dataset) => {
        const automateKey = dataset?.devices?.[0]?.automates?.[0]?.llave;
        const variableKey = dataset?.variable;
        const variable = VARS_CATALOGO?.find(item =>
            item.key === variableKey &&
            (!automateKey || item.group?.key === automateKey)
        );
        return variable?.name ?? '';
    };
    return (
        <Box>
            <Dialog
                className={classes.dialogStyle}
                open={openDataSetFilter}
                onClose={handleOpenDataSet}
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullWidth
            >
                <DatasetFilter
                    statusNodes={statusNodes}
                    initialDataset={filter?.groups?.['1']?.dataSets?.[indexDataSetSelected] ? filter?.groups?.['1']?.dataSets[indexDataSetSelected] : DATASET_INITIAL_VALUES}
                    indexDataSetSelected={indexDataSetSelected}
                    indexGroupSelected={1}
                    handleDataSetChanges={handleDataSetChanges}
                    setOpenDataSetFilter={setOpenDataSetFilter}
                    varsCatalog={VARS_CATALOGO}
                />
            </Dialog>

            {!loading ?
                <Box height='500px' display='flex' justifyContent='center' alignItems={'center'}>
                    <CircularProgress />
                </Box>
                :

                <Box >
                    <Box
                        ml={3}
                        display="flex"
                        alignItems="center"
                        flexWrap={'wrap'}
                        minHeight={40}
                    >
                        <Tooltip
                            title="Elija el/los dispositivos que desea añadir al gráfico principal haciendo click en el botón +"
                            arrow
                            placement="right"
                        >
                            <Box className={clsx(classes.hint, classes.leftSpacing, { [classes.tick]: activeStep >= 1 })}  >
                                {activeStep >= 1 ? <DoneIcon style={{ padding: '2px' }} /> : 1}
                            </Box>
                        </Tooltip>
                        <Box className={classes.devicesLabel}>
                            Agregar dataset
                        </Box>
                        <IconButton
                            aria-label="Agregar dataset"
                            className={classes.addBtn}
                            onClick={handleOpenDataSet}
                        >
                            <AddIcon fontSize="small" />
                        </IconButton>
                        {filter?.groups?.['1']?.dataSets?.length > 0 &&
                            filter?.groups?.['1']?.dataSets?.map((dataset, indexDataSet) => {
                                dataset.variableName = validateVarNameSelected(dataset)
                                return <Chip
                                    key={dataset.id}
                                    icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                                    label={getChipLabel(dataset)}
                                    clickable
                                    color="primary"
                                    onClick={() => handleOpenDataSet(indexDataSet)}
                                    onDelete={() => handleDeleteDataSet(indexDataSet)}
                                    className={classes.filterChip}
                                />
                            }
                            )}
                    </Box>

                    <Box
                        mt={2}
                        ml={3}
                        display="flex"
                        alignItems="center"
                        flexWrap={'wrap'}
                        minHeight={40}
                    >
                        <Tooltip
                            title="Elija el/los dispositivos que desea añadir al gráfico principal haciendo click en el botón +"
                            arrow
                            placement="right"
                        >
                            <Box className={clsx(classes.hint, classes.leftSpacing, { [classes.tick]: activeStep >= 2 })}  >
                                {activeStep >= 2 ? <DoneIcon style={{ padding: '2px' }} /> : 2}
                            </Box>
                        </Tooltip>
                        <Box className={classes.devicesLabel}>
                            Seleccione Periodo
                        </Box>

                        <Box mt={2} mb={2} width={'90%'}>
                            <Box mb={1} display='flex' justifyContent='center'>
                                <span className={classes.tabsTitle}>Periodo</span>
                            </Box>
                            <Box>
                                <FormControl component='fieldset' fullWidth>
                                    <RadioGroup
                                        aria-label='chosen_range'
                                        name='chosen_range'
                                        value={stateComponent?.filter_key?.range}
                                        onChange={handlePeriod}
                                        className={classes.radio}
                                    >
                                        {
                                            arrayGranularityValue.map(option => (
                                                <FormControlLabel
                                                    disabled={disabledGranularity()}
                                                    key={option.key}
                                                    value={option.key}
                                                    control={<Radio color='primary' />}
                                                    label={option.name}
                                                />
                                            ))
                                        }
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }

        </Box>
    );
}